import { Component, OnInit, ElementRef, ViewChild, HostListener } from '@angular/core';
import { CommonHelper } from './../../shared/helpers/CommonHelper';
import { CnaeSearch } from './../../models/CnaeSearch.model';
import { CnaeService } from './../../services/cnae.service';
import { Cnae } from '../../models/Cnae.model';
import { Json2csvService } from "../../services/json2csv.service";
import { DropDownList } from '../../models/DropDownList.model';
import { LocalStorage } from '../../shared/wrappers/LocalStorage';
import { ToastsManager } from 'ng2-toastr';
import {​​​ ErrorHandlerProvider }​​​ from'../../shared/providers/errorHandler.provider';

@Component({
    selector: 'app-cnaes',
    templateUrl: './cnaes.component.html',
    styleUrls: ['./cnaes.component.css']
})
export class CnaesComponent implements OnInit {
    @ViewChild("buttonModalCnaeStatus") buttonModalCnaeStatus: ElementRef;
    loading: boolean;
    cnaes: Cnae[] = new Array<Cnae>();

    commonHelper: CommonHelper = new CommonHelper();
    cnaeSearchModel: CnaeSearch;
    cnae: Cnae = new Cnae();
    cnaeAux: Cnae = new Cnae();

    dropDownListTypes: DropDownList[] = new Array<DropDownList>();
    selectedTypeItems: DropDownList[] = new Array<DropDownList>();
    dropDownTypeSettings = {};

    dropDownListStatus: DropDownList[] = new Array<DropDownList>();
    selectedStatusItems: DropDownList[] = new Array<DropDownList>();
    dropDownStatusSettings = {};

    itemsPerPage: number[] = [10, 50, 100];
    totalItems: number = 5;
    currentPage: number = 1;

    constructor(
        private cnaeService: CnaeService,
        private json2csvService: Json2csvService,
        private localStorage: LocalStorage,
        private toastr: ToastsManager,
        private errorHandler: ErrorHandlerProvider
    ) { }

    async ngOnInit() {
        this.loading = true;

        this.dropDownListStatus = [
            { id: 'true', itemName: 'Ativo' },
            { id: 'false', itemName: 'Inativo' }
        ];

        this.dropDownListTypes = this.commonHelper.getAllSapItemType().map(item => ({
            id: String(item), itemName: this.commonHelper.transcriptSapItemType(item)
        }));

        this.dropDownStatusSettings = this.commonHelper.getDropDownSettings(false, 'Status', false, 'Marcar todas os status', 'Desmarcar todas os status', false, null, '');
        this.dropDownTypeSettings = this.commonHelper.getDropDownSettings(false, 'Tipo', false, 'Marcar todas os tipos', 'Desmarcar todas os tipos', false, null, '');

        if (this.localStorage.retrieve("cnae"))
            this.setFilters();
        else
            this.cnaeSearchModel = new CnaeSearch();

        await this.search(1);

        this.loading = false;
    }

    @HostListener('window:keyup', ['$event'])
    keyEvent(event: KeyboardEvent){
        if(event.keyCode === 13) {
            this.search(1)
        }
    }

    onChange() {
        this.localStorage.persist("cnae", {
            cnaeSearchModel: this.cnaeSearchModel,
            selectedStatusItems:this.selectedStatusItems,
            selectedTypeItems: this.selectedTypeItems
        });
    }

    setFilters(){
        let storage = this.localStorage.retrieve("cnae");
        if(storage.cnaeSearchModel)
            this.cnaeSearchModel = storage.cnaeSearchModel;
        this.selectedStatusItems = storage.selectedStatusItems?storage.selectedStatusItems:[];
        this.selectedTypeItems = storage.selectedTypeItems?storage.selectedTypeItems:[];
    }

    async search(page?: number) {
        this.loading = true;
        this.currentPage = page ? page : 1;
        this.cnaeSearchModel.skip = (page - 1) * this.cnaeSearchModel.limit;

        this.cnaeSearchModel.types = [];
        this.cnaeSearchModel.status = [];

        for(let type of this.selectedTypeItems)
            this.cnaeSearchModel.types.push(parseInt(type.id));

        for(let status of this.selectedStatusItems)
            this.cnaeSearchModel.status.push(status.id);

        this.cnaes = await this.cnaeService.searchCnae(this.cnaeSearchModel);

        this.totalItems = this.cnaeSearchModel.totalItems;
        this.onChange();
        this.loading = false;
    }

    isActive(active: boolean) {
        return active ? "badge-success" : "badge-danger";
    }

    isActiveText(active: boolean) {
        return active ? "Ativo" : "Inativo";
    }

    openModalCnaeStatus(cnae: any){
        this.cnaeAux = { ...cnae };
        this.buttonModalCnaeStatus.nativeElement.click();
    }

    async close() {
        this.cnaeAux = new Cnae();
        await this.search(1);
    }

    async changeCnaeStatus() {
        try{
            let response = await this.cnaeService.update(this.cnaeAux);
            if(response._id)
                this.toastr.success(`Status do Item foi atualizado com sucesso.`);
            else
                this.errorHandler.interceptError(response, `CNAEs e Itens`);
            await this.close();
        } catch(err){
            this.errorHandler.interceptError(err, 'CNAEs e Itens');
            await this.close();
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/views/cnaes/cnaes.component.ts